export default __webpack_public_path__ + "static/media/Quickness.c71c0535.png";